import { render, staticRenderFns } from "./documentsTable.vue?vue&type=template&id=4e18de7c&lang=pug"
import script from "./documentsTable.vue?vue&type=script&lang=js"
export * from "./documentsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports